module.exports = __webpack_public_path__ + "img/icon-menu-users.c3ca8e4c.svg";